import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const amenityTypes = ["FEATURED", "GENERAL"] as const;
type AmenityType = (typeof amenityTypes)[number];
const amenityType = toObjectMap([...amenityTypes]);

const amenityTypeZodEnum = z.enum(amenityTypes);

export { amenityType, amenityTypeZodEnum, amenityTypes };
export type { AmenityType };
